var template = function(data) { // https://select2.org/selections#templating
  // console.log(data)

	if (!data.element) // подавляем вызов для поля поиска
		return null;   // (вызов происходит даже если поиск отключен)

	var country = data.text;
	let flag_name = data.element.dataset.countryFlag;
	// let flag_name = data.element.dataset.countryflag;
  // console.log(flag_name)
	var option = $('<span class="has-countryflag">' + country + '</span>');
	if (flag_name) {
		var src = './img/' + flag_name + '.svg';
    // console.log(src);

		option.css( 'background-image', 'url(' + src + ')' );
	}
	return option;
};

$('select').select2({
		minimumResultsForSearch: Infinity, // убираем текстовое поле поиска
		templateSelection: template,       // вид <select>
		templateResult:    template,        // вид <option> в выпадающем списке
});

// import Choices from 'choices.js';

// let item1;

// const choices = new Choices('[data-select]', {
  // callbackOnInit: () => {
  //   item1 = document.querySelector('[data-id="1"]')
  //   let item2 = document.querySelector('[data-id="2"]')
  //   item1.innerHTML = '<img src="./img/canada1.svg">';
  //   item2.innerHTML = '<img src="./img/flag.svg">';
  //   console.log(item1)
  //   console.log(item2)

  // }
// });

// $('#demo-htmlselect').ddslick({
//   onSelected: function(selectedData){
//       //callback function: do something with selectedData;
//   }
// });

// console.log($)
// console.dir($)

// let select = document.querySelector()
